import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

/**
 * The production build is prerendered, so React attaches to existing markup.
 * The dev server serves an empty #root, so there is nothing to attach to and we
 * mount from scratch instead — hydrating an empty container would warn on every
 * page load.
 */
if (container.hasChildNodes()) {
    hydrateRoot(
        container,
        <StrictMode>
            <App />
        </StrictMode>,
    );
} else {
    createRoot(container).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
}
